<mat-tab-group (selectedIndexChange)="updateTab($event)" [@.disabled]="true" id="heatmaps">
  <mat-tab *ngFor="let map of heatmaps" label="{{map.textContent}}">
    <div [hidden]="!loaded" [innerHTML]="page" classx="scroll-wrap stickyheaders-holder"></div>
    <div [hidden]="loaded" class="spinner-wrap">
      <xormon-loading-indicator></xormon-loading-indicator>
    </div>
  </mat-tab>
</mat-tab-group>
